export default __webpack_public_path__ + "static/media/ultrafine.9661761b.png";